import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, BookOpen, Layers, GraduationCap, Puzzle, Users, CreditCard, Settings, LogOut, ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin", label: "Visão Geral", icon: LayoutDashboard, end: true },
  { to: "/admin/cursos", label: "Cursos", icon: BookOpen },
  { to: "/admin/aulas", label: "Aulas", icon: GraduationCap },
  { to: "/admin/puzzles", label: "Puzzles", icon: Puzzle },
  { to: "/admin/alunos", label: "Alunos", icon: Users },
  { to: "/admin/assinaturas", label: "Assinaturas", icon: CreditCard },
  { to: "/admin/configuracoes", label: "Configurações", icon: Settings },
];

export default function AdminLayout() {
  const loc = useLocation();
  const nav = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-chessup-bg flex">
      <aside className="w-16 md:w-64 border-r border-chessup-border bg-chessup-deep sticky top-0 h-screen p-3 md:p-5 flex flex-col">
        <Link to="/admin" className="mb-8 hidden md:block"><Logo size={38} /></Link>
        <div className="mb-6 md:hidden flex justify-center"><Logo size={36} /></div>
        <nav className="flex-1 space-y-1">
          {NAV.map((n) => {
            const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            const Icon = n.icon;
            return (
              <Link key={n.to} to={n.to} data-testid={`anav-${n.label}`}
                className={`flex items-center gap-3 rounded-lg px-2 md:px-3 py-2.5 text-sm transition-colors justify-center md:justify-start ${active ? "bg-chessup-gold/12 text-chessup-goldlight border border-chessup-gold/30" : "text-chessup-subtext hover:text-chessup-text hover:bg-chessup-card"}`}>
                <Icon style={{ width: 18, height: 18 }} /> <span className="hidden md:inline">{n.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="space-y-1 pt-4 border-t border-chessup-border">
          <Link to="/painel" className="flex items-center gap-2 text-sm text-chessup-subtext hover:text-chessup-turq px-2 md:px-3 py-2 justify-center md:justify-start">
            <ArrowLeft style={{ width: 18, height: 18 }} /> <span className="hidden md:inline">Voltar ao app</span>
          </Link>
          <button onClick={() => { logout(); nav("/"); }} className="w-full flex items-center gap-2 text-sm text-chessup-subtext hover:text-chessup-text px-2 md:px-3 py-2 justify-center md:justify-start">
            <LogOut style={{ width: 18, height: 18 }} /> <span className="hidden md:inline">Sair</span>
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0"><Outlet /></div>
    </div>
  );
}
